export const userKeys = {
  devices: ["user-devices"],
  request_otp: ["request_otp"],
  points: ["points"],
};
